import style from './style.module.scss';

const ResetAndViewButton = ({
  clickResetButton,
  length,
  setFilterActiveEvent,
  setIsModalVisibleEvent,
  width,
  detailPage,
  updateBookmarkId,
  bookmarkName,
  setUpdateBookmarkEvent
}) => {
  return (
    <>
      {/* {!detailPage && ( */}
      <>
        <div
          className={`${style['op-abs-btn']} flex flex-wrap  justify-center justify-between mt-8 md:flex-col items-center md:items-center lg:flex-row mobile`}
          style={{ marginTop: '64px', padding: '0 16px' }}
        >
          <button
            className={`${style['task-card-header']} btn-small mb-4 btn-small-grey`}
            onClick={clickResetButton}
          >
            RESET
          </button>

          <button
            className={`${style['task-card-header']} btn-small mb-4`}
            onClick={() => setFilterActiveEvent(false)}
          >
            VIEW {<span>({length?.toLocaleString()})</span>}
          </button>
        </div>

        {!detailPage ? (
          <div className="text-center" style={{ marginTop: '64px' }}>
            <button
              onClick={() => {
                if (width < 768) setFilterActiveEvent(false);

                if (updateBookmarkId) setUpdateBookmarkEvent();
                else setIsModalVisibleEvent(true);
              }}
              className={`${style['task-card-header']} ${style['op-bookmark-filter']} text-center`}
            >
              {updateBookmarkId ? (
                <div className={style.updateBookmarkText}>
                  <p>
                    Save changes to <span>{bookmarkName}</span> bookmark
                  </p>
                </div>
              ) : (
                <>BOOKMARK FILTER</>
              )}
            </button>
          </div>
        ) : (
          <></>
        )}
      </>
      {/* )} */}
    </>
  );
};

export default ResetAndViewButton;
